// Common color values used throughout the app
export const COLORS = {
  primary: '#0D0D0D',
  secondary: '#666666',
  muted: '#999999',
  lightGray: '#E5E5E5',
  background: '#F7F7F7',
  white: '#FFFFFF',
  accentGreen: '#9ef34a',
  darkGreen: '#6eb32a',
  separatorGray: '#999999',
};

// Common spacing values
export const SPACING = {
  section: 'py-12 md:py-16',
  container: 'px-6 md:px-12',
  scrollOffset: 'scroll-mt-32',
};

// Common text styles
export const TEXT_STYLES = {
  heading: 'text-2xl md:text-3xl font-playfair font-normal text-[#0D0D0D]',
  subheading: 'text-lg font-medium text-[#0D0D0D]',
  body: 'text-base text-[#666666] font-normal leading-relaxed',
  small: 'text-sm text-[#666666] font-normal',
  muted: 'text-xs text-[#999999]',
};

// Common border styles
export const BORDER_STYLES = {
  default: 'border border-[#E5E5E5]',
  rounded: 'rounded-lg',
  roundedFull: 'rounded-full',
};

// Primary CTA button styles
export const BUTTON_STYLES = {
  primary: 'inline-flex items-center gap-2 bg-[#1A1A1A] text-white font-normal hover:bg-[#CBFB8F] hover:text-[#1A1A1A] transition-all text-base md:text-lg px-6 py-3 rounded-full',
  secondary: 'inline-flex items-center gap-2 bg-transparent text-[#0D0D0D] font-normal border-2 border-[#0D0D0D] hover:bg-[#0D0D0D] hover:text-white transition-all text-base md:text-lg px-6 py-3 rounded-full',
};
